export default "__VITE_ASSET__dafab795__"